import { notificationsAfterLogin, notificationsBeforeLogin, MessageData } from "../notifications";


const generateId = () => Math.random().toString(36).substring(2, 9);

export const addAfterLoginNotification = (message: string, type: "info" | "success" | "error") => {
  notificationsAfterLogin.value = [
    ...notificationsAfterLogin.value,
    { id: generateId(), message, type },
  ];
};

export const addBeforeLoginNotification = (message: string, type: "info" | "success" | "error") => {
  notificationsBeforeLogin.value = [
    ...notificationsBeforeLogin.value,
    { id: generateId(), message, type },
  ];
};
